import React from "react";
import "./StartGame.css";
import playButton from "../../assets/img/button.png";
import trophyIcon from "../../assets/img/trophy.png";
import crownIcon from "../../assets/img/crown.png";

export default function StartGame({
    backgroundImage,
    onStart,
    yourBest,
    goqiiBest,
    hbTitle="Health Benefits",
    hbHeading,
    hbDescription,
}) {
    return (
        // ✅ Added scoped class "start-game-container"
        <div
            className="hb-wrapper start-game-container"
            style={{ backgroundImage: `url(${backgroundImage})` }}
        >
            {/* 1. Top Card */}
            <div className="hb-card">
                <div className="hb-card-title">{hbTitle}</div>
                <h3 className="hb-card-heading">{hbHeading}</h3>
                <p className="hb-card-desc">{hbDescription}</p>
            </div>

            {/* 2. Middle Section: Scores (Grouped for better layout) */}
            <div className="hb-scores-section">
                <div className="hb-scores-title">High Scores</div>

                <div className="hb-score-row">
                    <div className="hb-score-box">
                        <div className="hb-icon-wrapper">
                            <img src={trophyIcon} className="hb-score-icon" alt="Trophy" />
                        </div>
                        <p className="hb-score-label">Your Best</p>
                        <p className="hb-score-value">{yourBest}</p>
                    </div>

                    <div className="hb-score-box">
                        <div className="hb-icon-wrapper hb-icon-top">
                            <img src={crownIcon} className="hb-score-icon" alt="Crown" />
                        </div>
                        <p className="hb-score-label">GOQii Best</p>
                        <p className="hb-score-value">{goqiiBest}</p>
                    </div>
                </div>
            </div>

            {/* 3. Play Button */}
            <img
                src={playButton}
                alt="Start Game"
                className="hb-play-btn"
                onClick={onStart}
            />
        </div>
    );
}